'use client'

import { type FC, Fragment, type ReactNode } from 'react'

import { type ChatMessage, formatAiResponse } from '@/entities/ai-chat'

import { createMarkup } from '@/shared/lib/utils/common/createMarkup'

import { MessageProductCards } from './MessageProductCards'
import { NeedAuthButton } from './need-auth-button'

import cl from './messege-item.module.scss'

const PRODUCT_PLACEHOLDER_RE = /<div id="product-[^"]+"><\/div>/g
const NEED_AUTH_BUTTON_RE = /<need-auth-button\s*(?:\/>|><\/need-auth-button>)/gi

const renderHtmlContent = (html: string, key: string) => {
	const parts = html.split(NEED_AUTH_BUTTON_RE)

	if (parts.length === 1) {
		return <div key={key} className={cl.messageContent} dangerouslySetInnerHTML={createMarkup(html)} />
	}

	return (
		<div key={key} className={cl.messageContent}>
			{parts.map((part, index) => (
				<Fragment key={`${key}-${index}`}>
					{!!part && <span dangerouslySetInnerHTML={createMarkup(part)} />}
					{index < parts.length - 1 && <NeedAuthButton />}
				</Fragment>
			))}
		</div>
	)
}

const renderMessageWithCards = (msg: ChatMessage) => {
	const content = formatAiResponse(msg.content)
	const nodes: ReactNode[] = []

	if (content.match(PRODUCT_PLACEHOLDER_RE)) {
		const [topText, bottomText] = content.split(PRODUCT_PLACEHOLDER_RE)

		if (topText) {
			nodes.push(renderHtmlContent(topText, 't-topText'))
		}

		if (msg.meta?.cards?.length) {
			nodes.push(<MessageProductCards key="c-poroductCards" groups={[msg.meta?.cards[0]] as any} />)
		}

		if (bottomText) {
			nodes.push(renderHtmlContent(bottomText, 't-bottomText'))
		}

		return nodes
	}

	nodes.push(renderHtmlContent(content, 't-topText'))

	return nodes
}

export const MessageItem: FC<{ message: ChatMessage }> = ({ message }) => {
	return (
		<div className={`${cl.message} ${message.role === 'user' ? cl.userMessage : cl.botMessage}`}>
			{message.role === 'assistant' && message.id !== 'stream-message' ? (
				<div>{renderMessageWithCards(message)}</div>
			) : (
				<div
					className={cl.messageContent}
					dangerouslySetInnerHTML={createMarkup(formatAiResponse(message.content))}></div>
			)}
			{message.created_at && (
				<div className={cl.timestamp}>
					{new Date(message.created_at).toLocaleTimeString('ru-RU', {
						hour: '2-digit',
						minute: '2-digit'
					})}
				</div>
			)}
		</div>
	)
}
